import React from 'react';

const TagUsuario = (props) => {
    return (
        <li className="bottom-separator-xxs">
            <div className="btn-group">
                <button type="button" className="btn-tag btn-tag-big btn-tag-closable btn-tag-closable-left not-clickable">{props.nombre}</button>
            </div>
        </li>
    );
}

export default TagUsuario;